import { useRouter } from "next/router";

import { Box, Flex, Text, Link } from "@chakra-ui/react";

import { IconBackgroundContainer } from "theme";
import { ChervonRight } from "icons";

import Icon from "@components/Icon";

import { LinkOption } from "@customtypes/global";
import { IIndexable } from "@customtypes/common";

import { getBlockChainIcon } from "@utils/globalCommon";
import { getQueryString } from "@utils/common";
import { useDappSDKProvider } from "dapp-sdk-v2";

interface LiquidStakingProps {
  blockChains: LinkOption[];
  onClick(key: string): void;
}

const orderMapping: IIndexable = {
  eth: 1,
  polygon: 2,
  bnb: 3,
  hedera: 4,
  fantom: 5,
  near: 6,
  terra: 7,
};

const LiquidStaking = ({ blockChains, onClick }: LiquidStakingProps) => {
  const { isEmbed } = useDappSDKProvider();
  const router = useRouter();
  const { query } = router;
  const queryString = getQueryString(query);

  const formattedBlockchains = blockChains.sort(
    (a, b) => orderMapping[a.key] - orderMapping[b.key]
  );

  if (isEmbed) return null;

  return (
    <>
      <Text
        fontWeight="700"
        fontSize="10px"
        lineHeight="16px"
        letterSpacing="0.5px"
      >
        EXPLORE LIQUID STAKING
      </Text>
      {formattedBlockchains.map((chain) => (
        <Link
          cursor="pointer"
          href={`${chain.link}${queryString ? `?${queryString}` : ""}`}
          onClick={() => onClick(chain.key)}
          p="0 0.5rem 0 1rem"
          key={chain.key}
          h="24px"
          w="176px"
          mt="1rem"
          rel="canonical"
        >
          <Flex alignItems="center" justifyContent="space-between">
            <Flex alignItems="center">
              <IconBackgroundContainer
                h="24px"
                w="24px"
                color="textSecondary"
                bg="backgroundSecondary"
              >
                <Icon
                  Icon={getBlockChainIcon(chain.key)}
                  width="14px"
                  height="14px"
                />
              </IconBackgroundContainer>
              <Text
                ml="0.5rem"
                fontWeight="500"
                fontSize="12px"
                color="textPrimary"
                _hover={{
                  color: "textSecondary",
                }}
              >
                {chain.title}
              </Text>
            </Flex>
            <Box
              color="primary"
              _dark={{
                color: "textPrimary",
              }}
            >
              <Icon width="24px" height="24px" Icon={ChervonRight} />
            </Box>
          </Flex>
        </Link>
      ))}
    </>
  );
};

export default LiquidStaking;
